import API from './config'

export const ImprovementAPI = {
    async createImprovement(improvement) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/improvements/createImprovement', improvement, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async updateImprovement(improvement) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.put('/improvements/updateImprovement', improvement, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async deleteImprovement(id) {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.delete('/improvements/deleteImprovement/' + id, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR: ", error.response)

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAllImprovements() {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/improvements/listAllImprovements', config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },

    async getAllImprovementTypes() {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get('/improvements/listAllImprovementTypes', config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }

    },
}